import MenuHeader from "./MenuHeader";

export default function UserProfile() {
    return (<div className="bg-white m-5 rounded-xl p-5">
        <div className="w-40 h-40 relative mx-auto">
            <img className="w-40 h-40 rounded-full justify-self-center object-cover" src="https://cdn.dribbble.com/userupload/3396433/file/original-a7938da0f7cbc7a5a75d4237da6d2d02.png?resize=1024x768&vertical=center" />
            <div className="bg-secondary-500 rounded-full absolute -bottom-2 inset-x-8  shadow shadow-secondary-500/25">
                <div className="w-32 h-8 table-cell align-middle text-sm text-center text-white">
                    <i className="fa-solid fa-pen"></i> ویرایش
                </div>
            </div>
        </div>
        <div className="mt-5 text-center">
            <h3 className="text-xl font-bold">حسن میرطالبی</h3>
            <p className="">09162533165</p>
        </div>
        <div className="flex mt-2 gap-2">
            <div className="bg-orange-500 h-16 flex-grow rounded-xl text-center text-white flex-col flex justify-center">
                <i className="text-lg fa-solid fa-medal"></i>
                <p className="text-sm">پکیج</p>
            </div>
            <div className="bg-purple-500 h-16 flex-grow rounded-xl text-center text-white flex-col flex justify-center">
                <p className="font-bold text-2xl">103</p>
                <p className="text-sm">سطح</p>
            </div>
            <div className="bg-blue-500 h-16 flex-grow rounded-xl text-center text-white flex-col flex justify-center">
                <p className="font-bold text-2xl">30</p>
                <p className="text-sm">مجموعه</p>
            </div>
        </div>
        <div className="text-center bg-green-500 h-6 rounded-full relative mt-2">
            <div className="h-6 rounded-full bg-green-700 w-64"></div>
            <p className="absolute top-0 left-0 right-0 text-center text-white">560,000 تومان تا سطح بعد</p>
        </div>
    </div>)
}